// ./client/src/components/NotifyEta.js
import { useAppContext } from "../../context/appContext";
import useSmsTask from "../../hooks/useSmsTask";
import React, { useState } from "react";

const formatEta = (time) => {
  if (!time) return "";
  const [hours, minutes] = time.split(":").map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return time;
  const suffix = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;
  return `${displayHours}:${String(minutes).padStart(2, "0")} ${suffix}`;
};

const NotifyEta = ({ customerPhone, testMode = false }) => {
  const { job, user } = useAppContext();
  const { status, error, sendSms } = useSmsTask();

  const [etaTime, setEtaTime] = useState("");

  const repName = user?.nickname || user?.full_name || "Your service rep";
  const messageText = `${repName} is on the way! ETA: ${formatEta(etaTime) || "shortly"}`;
  const jobId = job?.id

  const handleSend = () => {
    sendSms({
      customerPhone,
      text: messageText,
      jobId,
      repId: repName,
      testMode,
    });
  };

  const isBusy = ["Queued", "Sending"].includes(status);
  const hideButton =
    !testMode &&
    (!customerPhone || Number(user?.user_roles_id) > 1); // admin and developer only

  let feedback = "";
  if (isBusy) feedback = "Sending...";
  else if (status === "Delivered" || status === "Sent") feedback = "Customer notified!";
  else if (status === "Failed") feedback = error || "Failed to send";

  if (hideButton) return null;

  return (
    <div className="flex-parent">
      <div className="one-third">
        <input
          type="time"
          className="form-input"
          value={etaTime}
          onChange={(e) => setEtaTime(e.target.value)}
          disabled={isBusy}
          aria-label="ETA"
        />
      </div>
      <div className="two-thirds btn-block">
        <button className="btn" type="button" onClick={handleSend} disabled={isBusy}>
          {isBusy ? "Sending..." : "Notify Customer"}
        </button>
      </div>
      <div className="whole">
        {feedback && <p className={status === "Failed" ? "text-red" : "text-green"}>{feedback}</p>}
      </div>
    </div>
  );
};

export default NotifyEta;
